"use client";
import React, { useState, useEffect } from 'react';

const ScrollProgressIndicator: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPosition = window.scrollY;
      const scrollProgress = totalHeight > 0 ? scrollPosition / totalHeight : 0;
      setProgress(scrollProgress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-fox-orange to-fox-reddish-orange origin-left z-50"
      style={{ 
        transform: `scaleX(${progress})`,
        transformOrigin: 'left',
        transition: 'transform 0.1s ease-out'
      }}
    />
  );
};

export default ScrollProgressIndicator;
